webpackJsonp([61206194588026],{

/***/ 452:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/leveraging-cloud-services-results-in-seamless-distribution-of-lubricant-oil-in-mena/"},"frontmatter":{"title":"Leveraging Cloud Services Results in Seamless Distribution of Lubricant Oil in MENA"}}}]}},"pathContext":{"tag":"businessdevelopment"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-businessdevelopment-71fe8f98f92b41d844f3.js